/**
 * Web Audio 合成音效（拾起 / 吸附 / 完成），无外部音频文件，懒加载。
 * 遵循浏览器自动播放策略：首次交互（拾起）后才创建/恢复 AudioContext。
 */

let ctx: AudioContext | null = null;
let muted = false;

function ac(): AudioContext | null {
  if (muted) return null;
  if (!ctx) {
    const AC = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

function tone(freq: number, dur: number, type: OscillatorType, gain: number, when = 0): void {
  const c = ac();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + when;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.008);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.start(t);
  o.stop(t + dur + 0.02);
}

export const sfx = {
  setMuted(m: boolean): void {
    muted = m;
  },
  isMuted(): boolean {
    return muted;
  },
  pick(): void {
    tone(420, 0.07, 'triangle', 0.12);
  },
  snap(): void {
    tone(660, 0.1, 'sine', 0.2);
    tone(990, 0.09, 'sine', 0.12, 0.05);
  },
  complete(): void {
    [523, 659, 784, 1047].forEach((f, i) => tone(f, 0.32, 'triangle', 0.18, i * 0.12));
  },
};

export type Sfx = typeof sfx;
